import {
  ApplicationMainModelFileTypeEnum,
  ContentType,
  ContentTypeEnum,
  ExperimentBundleSubType,
  UserLibraryContent,
} from "../../../generated/graphql";
import { BundleNames } from "./constants";

export type CurrentBundleType = {
  manifest?: string;
  file?: string;
  id?: string;
  resources?: string;
  resourcesManifest?: string;
};

export type CurrentFileType = {
  image: string;
  name: string;
  type: string;
} | null;

export type ExperimentsTypes = {
  type: ContentTypeEnum;
  text: string;
  disabled?: boolean;
};

export type RequiredFieldsType =
  | string
  | null
  | []
  | ContentType
  | UserLibraryContent;

export enum ExperimentFieldTypes {
  Bundle = "file",
  Manifest = "manifest",
}

export type BundleDataType = {
  name: BundleNames;
  currentModelLink?: string | undefined;
  type: ExperimentBundleSubType | ExperimentFieldTypes;
  fileType: ApplicationMainModelFileTypeEnum;
};
